import React from "react";
import {calcTimeDiff} from "../chatbotUtil";
import {ChatMessage, mainColourSelector} from "../chatbotSlice";
import {useAppSelector} from "../../app/hooks";

interface UserMessageProps {
    index: number;
    message: ChatMessage;
    messages: ChatMessage[];
}

export const UserMessage: React.FC<UserMessageProps> = ({index, message, messages}) => {
    const mainColor = useAppSelector(mainColourSelector);

    return <div
        key={index}
        className="mt-1 flex flex-row justify-end"
    >
        <div className="max-w-[85%]">
            <div className="flex-col">
                <div
                    className={`rounded-2xl px-4 py-3 text-white whitespace-pre-wrap overflow-wrap-anywhere selectionText`}
                    style={{backgroundColor: mainColor}}>
                    {message.message.message}
                </div>
                {(index === messages.length - 1 ||
                    messages[index + 1].isBot) && (
                    <div
                        className="mt-1 text-right text-gray-500 text-[12px]"
                        suppressHydrationWarning>
                        {calcTimeDiff(message.time)}
                    </div>
                )}
            </div>
        </div>
    </div>
}
